import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft, FaSpinner } from 'react-icons/fa';
// import './Leads.css';

import Breadcrumb from '../Breadcrumb';
import { toast, ToastContainer } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LeadsForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [leadData, setLeadData] = useState({
    business_name: '',
    contact_name: '',
    phone_number: '',
    email: '',
    bussiness_address: '',
    service_interest: '',
    lead_status: '',
    notes: '',
    assigned_affiliate: ''
  });

  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(!!id);
  const [error, setError] = useState({});
  const [success, setSuccess] = useState('');


  const routes = [
    { name: 'Home',  path: '/dashboard' },
    { name: 'Leads', path: '/leads' },
    { name:'Create', path:'/leads/create'}
  
  ];

  useEffect(() => {
    const fetchLeads = async () => {
      if (id) {
        try {
          const token = localStorage.getItem('token');
          const response = await axios.get(`${API_BASE_URL}get-lead/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setLeadData(response.data.leads);
        } catch (err) {
          setError({ form: 'Error fetching lead data.' });
          console.error("Error fetching lead:", err);
        } finally {
          setInitialLoading(false);
        }
      }
    };
    fetchLeads();
  }, [id]);

 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeadData((prevData) => ({
      ...prevData,
      [name]: value
    }));
    setError((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError({});
    setSuccess('');

    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };

    try {
      const url = `${API_BASE_URL}add-update-leads/${id || 0}`;
      await axios.post(url, leadData, config);
      toast.success(id ? "Leads updated successfully!" : "Leads added successfully!")
      setLeadData({
        business_name: '',
        contact_name: '',
        phone_number: '',
        email: '',
        bussiness_address: '',
        service_interest: '',
        lead_status: '',
        notes: '',
        assigned_affiliate: ''
      });
      setTimeout(() => navigate('/leads'), 1000);
    } catch (err) {
      if (err.response && err.response.data) {
         console.log("Backend Error Response:", err.response.data); 
        const { args, message } = err.response.data;

        if (args && args.length > 0) {
          const validationErrors = args[0];
          let fieldErrors = {};
            Object.keys(validationErrors).forEach((field) => {
            fieldErrors[field] = validationErrors[field].join(' ');
          });

          setError(fieldErrors);
        } else {
          setError({ form: message || 'Error occurred. Please try again.' });
        }
      } else {
        setError({ form: id ? 'Error updating affiliate. Please try again.' : 'Error creating affiliate. Please try again.' });
      }
      setLoading(false);
    }
  };

 
  if (initialLoading) {
    return (
      <div className="d-flex">
       
        <div className='container my-5 flex-grow-1'>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column flex-md-row">
  
        <div className='container my-5 flex-grow-1'>
        <div className='d-flex'>
        <Breadcrumb routes ={routes}/>
        <button className="btn ls-btn ms-auto" style={{width:'120px',height:'50px'}} onClick={() => navigate('/leads')}>
          <FaArrowLeft /> Back
        </button>
        </div>
        <div className="card-header text-dark">
              <h3 className="mb-0">{id ? 'Update Lead' : 'Create Lead'}</h3>
        </div>
        <ToastContainer/>
          <div className="card white-box-shadow mt-4">
            <div className="card-body">
              {/* {loading && (
                <div className="alert alert-info d-flex align-items-center">
                  <FaSpinner className="spin me-2" /> {id ? 'Updating...' : 'Submitting...'}
                </div>
              )} */}
              {error.form && <div className="alert alert-danger">{error.form}</div>}
              {success && <div className="alert alert-success">{success}</div>}
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {['business_name', 'contact_name', 'phone_number', 'email', 'bussiness_address'].map((field, index) => (
                    <div className="col-12 col-md-6 mb-3" key={index}>
                      <label htmlFor={field} className="form-label">{field.replace('_', ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}:
                      {/* {field.replace('_', ' ').toUpperCase()}: */}
                          {field === 'business_name' && <span className="text-danger">*</span>}
                      </label>
                      <div className="input-group">
                        {/* <span className="input-group-text">
                          <i className={`bi bi-${field === 'phone_number' ? 'phone' : field === 'email' ? 'envelope' : 'person'}`}></i>
                        </span> */}
                        <input
                          type={field === 'phone_number' ? 'tel' : 'text'}
                          id={field}
                          name={field}
                          className="form-control"
                          placeholder={`Enter ${field.replace('_', ' ')}`}
                          value={leadData[field]}
                          onChange={handleChange}
                        />
                     
                      </div>
                         {error[field] && <div className="text-danger">{error[field]}</div>}
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <label htmlFor="service_interest" className="form-label">Service Interest:<span className="text-danger">*</span></label>
                    <select
                      id="service_interest"
                      name="service_interest"
                      className="form-control"
                      value={leadData.service_interest}
                      onChange={handleChange}
                    >
                      <option value="">Select Service Interest</option>
                      <option value="1">Website</option>
                      <option value="2">Google Listing</option>
                      <option value="3">E-Commerce</option>
                    </select>
                      {error.service_interest && <div className="text-danger">{error.service_interest}</div>}
                  </div>
                  <div className="col-12 col-md-6 mb-3">
                    <label htmlFor="lead_status" className="form-label">Lead Status:<span className="text-danger">*</span></label>
                    <select
                      id="lead_status"
                      name="lead_status"
                      className="form-control"
                      value={leadData.lead_status}
                      onChange={handleChange}
                    >
                      <option value="">Select Lead Status</option>
                      <option value="1">New</option>
                      <option value="2">Contacted</option>
                      <option value="3">Interested</option>
                      <option value="4">Converted</option>
                    </select>
                      {error.lead_status && <div className="text-danger">{error.lead_status}</div>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <label htmlFor="notes" className="form-label">Notes:</label>
                    <input
                      type="text"
                      id="notes"
                      name="notes"
                      className="form-control"
                      value={leadData.notes}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-3">
                    <label htmlFor="assigned_affiliate" className="form-label">Assigned Affiliate:<span className="text-danger">*</span></label>
                    <select
                      id="assigned_affiliate"
                      name="assigned_affiliate"
                      className="form-control"
                      value={leadData.assigned_affiliate}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">Tushar</option>
                      <option value="2">Upamanyu</option>
                      <option value="3">Dhanshri</option>
                      <option value="4">Kaveri</option>
                    </select>
                      {error.assigned_affiliate && <div className="text-danger">{error.assigned_affiliate}</div>}
                  </div>
                </div>
                <div className="d-grid col-2 mx-auto">
                  <button type="submit" className="btn ls-btn btn-lg" disabled={loading}>
                    {loading ? (
                      <FaSpinner className="spin me-2" />
                    ) : (
                      id ? 'Update' : 'Submit'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  );
};

export default LeadsForm;
